import React from "react";

export default () => {

    return <svg viewBox="0 0 337 336" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(0.468550, 0.000000)" fill="#000000" fillRule="nonzero">
                <path d="M0,168.0032 C0,164.9094 2.5078,162.4016 5.6016,162.4016 L330.4016,162.4016 C333.4954,162.4016 336.0032,164.9094 336.0032,168.0032 C336.0032,171.097 333.4954,173.6048 330.4016,173.6048 L5.6016,173.6048 C2.5078,173.6048 0,171.097 0,168.0032 Z"></path>
                <path d="M168,336.0032 C164.9062,336.0032 162.3984,333.4954 162.3984,330.4016 L162.3984,5.6016 C162.3984,2.5078 164.9062,0 168,0 C171.0938,0 173.6016,2.5078 173.6016,5.6016 L173.6016,330.4016 C173.6016,333.4954 171.0938,336.0032 168,336.0032 Z"></path>
            </g>
        </g>
    </svg>

}
